/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PlatformType = {
    Ios: 'IOS',
    Android: 'ANDROID',
    WebLogin: 'WEB_LOGIN',
    WebAdmin: 'WEB_ADMIN',
    WebCarrier: 'WEB_CARRIER',
    WebCustomer: 'WEB_CUSTOMER'
} as const;
export type PlatformType = typeof PlatformType[keyof typeof PlatformType];

